import Auth from "@/Auth.js";

export default (to, from, next) => {
  Auth.setItem("last_route", from.path);
  let user =
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"));

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!Auth.isLogged() || !user) {
      next({
        path: "/inscricao/auth/login",
      });
    } else {
      if (user && user.trocarSenhaLogin && to.name !== "auth.trocarSenha") {
        if (Auth.isLogged()) {
          console.log("next");
          next({
            path: "/inscricao/user/trocar-senha",
          });
        } else {
          next();
        }
      }
    }
  }
  if (to.matched.some((record) => record.meta.requiresFullAdmin)) {
    if (!Auth.isLogged()) {
      next({
        path: "/inscricao/auth/login",
      });
    } else {
      if (user.email != "admin@admin.com.br") {
        next({
          path: "/inscricao/auth/dashboard",
        });
      } else next();
    }
  }
  if (to.matched.some((record) => record.meta.requiresNoAuth)) {
    if (Auth.isLogged() && user && !user.trocarSenhaLogin) {
      next({
        path: "/inscricao/auth/dashboard",
      });
    } else {
      next();
    }
  } else {
    next();
  }
};
